import { addGlobalLiveEventListener, getFetchOptions, startIconLoading, stopIconLoading } from "../../utils";
import { StatusClassNames } from "../../types/StatusClassNames";
import EventBus from "../../events/EventBus";
import { useFavoritesApi } from "../../api/favoritesApi";
let api;
function highlightFavorites(updateBrands = true) {
    let brandsUpdated = false;
    for (const el of document.querySelectorAll(`.favorite-button`)) {
        const brand = el.dataset.brand !== undefined;
        const status = api.has(parseInt(el.dataset.id), brand);
        if (status) {
            el.classList.add(StatusClassNames.filled);
        }
        else {
            el.classList.remove(StatusClassNames.filled);
        }
        if (brand) {
            brandsUpdated = true;
            updateBrandCategories(el, status);
        }
    }
    if (brandsUpdated && updateBrands) {
        EventBus.emit('brands:update');
    }
}
addGlobalLiveEventListener('click', '.favorite-button', async function (e) {
    const id = parseInt(this.dataset.id);
    const brand = this.dataset.brand !== undefined;
    e.preventDefault();
    startIconLoading(this);
    try {
        const status = await useFavoritesApi().toggleFavorite(id, brand);
        if (status) {
            this.classList.add(StatusClassNames.filled);
            if (!brand) {
                window.vkEvent(process.env.VK_PRICE_LIST_ID, 'add_to_wishlist', { products: [{ id }] });
            }
        }
        else {
            this.classList.remove(StatusClassNames.filled);
        }
        if (brand) {
            updateBrandCategories(this, status);
        }
    }
    finally {
        stopIconLoading(this);
    }
});
function updateBrandCategories(button, status) {
    const parentListItem = button.closest('.abc-nav__item');
    if (!parentListItem) {
        return;
    }
    const list = new Set((parentListItem.dataset.category ?? '').split(' '));
    if (status) {
        list.add('favorite');
    }
    else {
        list.delete('favorite');
    }
    parentListItem.dataset.category = [...list].join(' ');
}
function onChange(event) {
    const checkbox = event.target;
    const fieldset = checkbox.closest('fieldset');
    fieldset.disabled = true;
    const body = {
        id: parseInt(checkbox.value),
        shelf: checkbox.name,
        remove: !checkbox.checked,
    };
    fetch('/api/wardrobe/append', getFetchOptions(body, true))
        .finally(() => fieldset.disabled = false);
}
export default function initFavorites() {
    api = useFavoritesApi();
    EventBus.on('favorites:change', () => highlightFavorites());
    window.addEventListener('pageshow', () => highlightFavorites());
    EventBus.on('products:load', () => highlightFavorites(false));
    EventBus.on('modal:open', modal => {
        if (modal.id === 'modal-add-to-favourites') {
            modal.querySelectorAll('input[type=checkbox]')
                .forEach(checkbox => checkbox.addEventListener('change', onChange));
        }
    });
    EventBus.on('modal:close', modal => {
        if (modal.id === 'modal-add-to-favourites') {
            modal.querySelectorAll('input[type=checkbox]')
                .forEach(checkbox => checkbox.removeEventListener('change', onChange));
        }
    });
}
